/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * The link between the categoryId and the name that should be used
 * @export
 * @interface PredictionTaskSchemaCategory
 *
 */
// create custom validators for the regexes
export interface PredictionTaskSchemaCategory {
    /**
     * The id of the category. Needs to be a positive integer but can be any integer (gaps are allowed, does not need to be sequential)
     * #type number
     * #memberof PredictionTaskSchemaCategory
        
    * @minimum 0
            
         */
    id: number;
    /**
     * The name of the category when it should be visualized
     * #type string
     * #memberof PredictionTaskSchemaCategory
        
        
    * @minLength 1
         */
    name: string;
}
/**
 * Check if a given object implements the PredictionTaskSchemaCategory interface.
 */
export function instanceOfPredictionTaskSchemaCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const PredictionTaskSchemaCategoryTypiaAssertEquals = (input: any) => {
    return ((input: any): PredictionTaskSchemaCategory => {
        const __is = (input: any, _exceptionable: boolean = true): input is PredictionTaskSchemaCategory => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.id && 0 <= input.id && ("string" === typeof input.name && 1 <= input.name.length) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PredictionTaskSchemaCategory => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.id && (0 <= input.id || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number (@minimum 0)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number",
                    value: input.id
                })) && ("string" === typeof input.name && (1 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 1)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "PredictionTaskSchemaCategory",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "PredictionTaskSchemaCategory",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const PredictionTaskSchemaCategoryTypiaAssertStringify = (input: PredictionTaskSchemaCategory): string => {
    return ((input: any): string => { const assert = (input: any): PredictionTaskSchemaCategory => {
        const __is = (input: any): input is PredictionTaskSchemaCategory => {
            return "object" === typeof input && null !== input && ("number" === typeof (input as any).id && !Number.isNaN((input as any).id) && 0 <= (input as any).id && ("string" === typeof (input as any).name && 1 <= (input as any).name.length));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PredictionTaskSchemaCategory => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.id && !Number.isNaN(input.id) && (0 <= input.id || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number (@minimum 0)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number",
                    value: input.id
                })) && ("string" === typeof input.name && (1 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 1)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "PredictionTaskSchemaCategory",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "PredictionTaskSchemaCategory",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: PredictionTaskSchemaCategory): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"id":${(input as any).id},"name":${$string((input as any).name)}}`;
    }; return stringify(assert(input)); })(input);
};
export const PredictionTaskSchemaCategoryValidatorShape = {
    'id': yup.number().min(0).defined(),
    'name': yup.string().min(1).defined(),
};
export const PredictionTaskSchemaCategoryValidator = yup.object().shape(PredictionTaskSchemaCategoryValidatorShape);
export const PredictionTaskSchemaCategoryStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'name': {
        'type': 'string',
        'minLength': 1,
    } as unknown as fastJSON.StringSchema,
};
export const PredictionTaskSchemaCategoryStringifyShape: ObjectSchema = {
    title: 'PredictionTaskSchemaCategory Stringifier',
    type: 'object',
    properties: {
        ...PredictionTaskSchemaCategoryStringifyShapeProperties
    },
    required: [
        'id',
        'name',
    ],
};
export const PredictionTaskSchemaCategoryStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(PredictionTaskSchemaCategoryStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const PredictionTaskSchemaCategoryStringify: (data: PredictionTaskSchemaCategory) => string = PredictionTaskSchemaCategoryStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function PredictionTaskSchemaCategoryFromJSON(json: any): PredictionTaskSchemaCategory {
    return PredictionTaskSchemaCategoryFromJSONTyped(json, false);
}
export function PredictionTaskSchemaCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictionTaskSchemaCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
export function PredictionTaskSchemaCategoryToJSON(value?: PredictionTaskSchemaCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
    };
}
